//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formulaDetail } from '../../../server/oldformula/'
export default {
  name: 'Euro_info',
  data () {
    return {
      formulaInfo: {},
      content: [],
      refList: [],
      id: '768'
    }
  },
  methods: {
    async getFormulaDetail () {
      var params = {
        uuid: this.id
      }
      try {
        const res = await formulaDetail(params)
        this.formulaInfo = res
        if (this.formulaInfo.introExplain) {
          this.content = JSON.parse(this.formulaInfo.introExplain)
        }
        if (this.formulaInfo.referenceNew) {
          this.refList = JSON.parse(this.formulaInfo.referenceNew)
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  created () {
    this.id = this.$route.query.id ? this.$route.query.id : this.id
    this.getFormulaDetail()
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/NewFormulas/Euro_info.vue